import { Box, Text, Flex } from "@chakra-ui/react";

interface UserMessageProps {
  text: string;
}

const UserMessage: React.FC<UserMessageProps> = ({ text }) => {
  return (
    <Flex justify="flex-end" w="100%">
      <Box
        bg="#EBEFF9"
        color="#667085"
        px={4}
        py={3}
        borderRadius="16px"
        maxW="720px"
      >
        <Text fontWeight={500}>{text}</Text>
      </Box>
    </Flex>
  );
};

export default UserMessage;
